import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import SettingsWrapper from '../SettingsWrapper.vue';
import CrmProductsIndex from './ProductsIndex.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/crm'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'crm_settings_products', params: to.params };
          },
        },
        {
          path: 'products',
          name: 'crm_settings_products',
          component: CrmProductsIndex,
          meta: {
            featureFlag: FEATURE_FLAGS.CRM,
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
